import script from "./setupHead.vue?vue&type=script&lang=ts&setup=true"
export * from "./setupHead.vue?vue&type=script&lang=ts&setup=true"

import "./setupHead.vue?vue&type=style&index=0&id=389d4456&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-389d4456"]])

export default __exports__